var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChatMess = function SvgChatMess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounselling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.1.9-Telecounsel-/-Queue----in-call---cam-off",
    transform: "translate(-920, -801)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(480, 784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-Copy",
    transform: "translate(424, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chatbox-ellipses",
    transform: "translate(16, 17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1428571,0 L3.85714286,0 C1.72788078,0.00236191241 0.00236191241,1.72788078 0,3.85714286 L0,14.1428571 C0.00236191241,16.2721192 1.72788078,17.9976381 3.85714286,18 L5.14285714,18 L5.14285714,21.4285714 C5.14276693,21.7612889 5.33522884,22.064 5.63655564,22.2050783 C5.93788244,22.3461567 6.29362872,22.3001114 6.54910714,22.0869643 L11.4503571,18 L20.1428571,18 C22.2721192,17.9976381 23.9976381,16.2721192 24,14.1428571 L24,3.85714286 C23.9976381,1.72788078 22.2721192,0.00236191241 20.1428571,0 Z M6.85714286,10.7142857 C5.910369,10.7142857 5.14285714,9.94677386 5.14285714,9 C5.14285714,8.05322614 5.910369,7.28571429 6.85714286,7.28571429 C7.80391671,7.28571429 8.57142857,8.05322614 8.57142857,9 C8.57142857,9.94677386 7.80391671,10.7142857 6.85714286,10.7142857 Z M12,10.7142857 C11.0532261,10.7142857 10.2857143,9.94677386 10.2857143,9 C10.2857143,8.05322614 11.0532261,7.28571429 12,7.28571429 C12.9467739,7.28571429 13.7142857,8.05322614 13.7142857,9 C13.7142857,9.94677386 12.9467739,10.7142857 12,10.7142857 Z M17.1428571,10.7142857 C16.1960833,10.7142857 15.4285714,9.94677386 15.4285714,9 C15.4285714,8.05322614 16.1960833,7.28571429 17.1428571,7.28571429 C18.089631,7.28571429 18.8571429,8.05322614 18.8571429,9 C18.8571429,9.94677386 18.089631,10.7142857 17.1428571,10.7142857 Z",
    id: "Shape"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatMess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat-mess.24a618a7.svg";
export { ForwardRef as ReactComponent };